const usdFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

/** Formats a price in cents as USD, e.g. 1250 -> "$12.50". */
export function formatTicketPrice(cents: number | null | undefined): string {
  return cents == null ? '' : usdFormatter.format(cents / 100)
}

/** Dollar amount for the price input, e.g. 1250 -> "12.50". */
export function centsToDollarInput(cents: number | null | undefined): string {
  return cents == null ? '' : (cents / 100).toFixed(2)
}

/** Parses a dollar input like "12.5" into cents; null when empty or not a positive amount. */
export function dollarInputToCents(input: string): number | null {
  const trimmed = input.trim()
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
    return null
  }
  const cents = Math.round(parseFloat(trimmed) * 100)
  return cents > 0 ? cents : null
}
